<template>
    <div>
        <v-card
            :color="color"
            :style="cardStyle"
            class="d-flex flex-column justify-content-center justify-center text-white dashboard-widget"
            height="150"
        >
            <v-card-title class="justify-end display-1">
                <slot name="card-title"></slot>
            </v-card-title>
            <v-card-text class="text-right text-white title">
                <slot name="card-text"></slot>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
export default {
    props: {
        icon: {
            type: String,
            required: true,
        },
        iconOpacity: {
            type: Number,
            required: false,
            default: 0.3,
        },
        color: {
            type: String,
            required: false,
            default: 'white',
        },
    },
    computed: {
        cardStyle() {
            return '--background: url(' + this.icon + '); --opacity: ' + this.iconOpacity;
        },
    },
};
</script>

<style scoped>
.dashboard-widget {
    display: block;
}

.dashboard-widget:after {
    content: '';
    background: var(--background);
    opacity: var(--opacity);
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    position: absolute;
    z-index: 0;
    background-repeat: no-repeat;
    background-size: 120px;
    background-position: -30px 45px;
}
</style>
